module.exports = __webpack_public_path__ + "img/globe-icon.6176aca7.svg";